import { render } from "./PageLeft.vue?vue&type=template&id=70bc1ef1&scoped=true"
import script from "./PageLeft.vue?vue&type=script&lang=js"
export * from "./PageLeft.vue?vue&type=script&lang=js"

import "./PageLeft.vue?vue&type=style&index=0&id=70bc1ef1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bc1ef1"]])

export default __exports__